"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editPilotLicenseHandler = exports.getLicenseTypesHandler = exports.createPilotProfileHandler = exports.editPilotProfileHandler = exports.getPilotProfileHandler = void 0;
const store_1 = require("../store/redux/store");
const account_1 = require("../store/redux/account");
const lodash_1 = require("lodash");
const pilot_1 = require("../http/pilot");
const userHandlers_1 = require("./userHandlers");
const getPilotProfileHandler = () => {
    (0, pilot_1.getPilotProfile)().then(response => {
        if (response.id) {
            store_1.store.dispatch((0, account_1.setPilotProfileAction)(response));
        }
        else {
            store_1.store.dispatch((0, account_1.setPilotProfileAction)({
                stopovers: false,
                bio: "",
                aircraft: [],
                license: {}
            }));
        }
    }).catch(error => {
        console.log(error);
    });
};
exports.getPilotProfileHandler = getPilotProfileHandler;
const editPilotProfileHandler = (data) => {
    (0, pilot_1.editPilot)(data).then(response => {
        store_1.store.dispatch((0, account_1.setPilotProfileAction)(response));
    }).catch(error => {
        console.log(error);
    });
};
exports.editPilotProfileHandler = editPilotProfileHandler;
const createPilotProfileHandler = (data) => {
    const filteredData = {
        ...data,
        aircraft: data.aircraft.map(addedAircraft => {
            let temp_aircraft = {
                ...(0, lodash_1.omit)(addedAircraft, 'id', 'icao_id', 'created_date', 'modified_date', 'value', 'label')
            };
            if (addedAircraft.edited)
                return temp_aircraft;
            else
                return { ...(0, lodash_1.omit)(temp_aircraft, 'manufacturer', 'model', 'type', 'serial_number') };
        })
    };
    (0, pilot_1.createPilotProfile)(filteredData).then(response => {
        store_1.store.dispatch((0, account_1.setPilotProfileAction)(response));
        (0, userHandlers_1.getUserDetailsHandler)();
    }).catch(error => {
        console.log(error);
    });
};
exports.createPilotProfileHandler = createPilotProfileHandler;
const getLicenseTypesHandler = () => {
    (0, pilot_1.getLicenseTypes)().then(response => {
        store_1.store.dispatch((0, account_1.setLicenseTypesAction)(response));
    }).catch(error => {
        console.log(error);
    });
};
exports.getLicenseTypesHandler = getLicenseTypesHandler;
const editPilotLicenseHandler = (data) => {
    (0, pilot_1.editPilotLicense)(data).then(response => {
        store_1.store.dispatch((0, account_1.setPilotProfileAction)({ license: response }));
    }).catch(error => {
        console.log(error);
    });
};
exports.editPilotLicenseHandler = editPilotLicenseHandler;
